<template>
  <ul v-if="doc.hasHighlights" class="highlights-content">
    <Highlight
      v-for="highlight in doc.highlights.slice(0, highlightsQty)"
      :key="highlight.id"
      :highlight="highlight"
      :doc="doc"
      :content="doc.currentPage"
    />
  </ul>

  <div v-else class="highlights__empty-container">
    <div class="highlights__image-wrapper">
      <!-- The src for this image is handled in the CSS -->
      <img alt="" />
    </div>
    <div class="highlights__text-box">
      <h2 class="highlights__title">Highlight Ideas</h2>
      <p class="highlights__description">
        Create highlights and add notes with your comments will appear here
      </p>
    </div>
    <AppButton
      class="highlight__button highlights__read-button"
      :class="hideButtonClass"
      tag="router-link"
      :icon="readingButton.icon"
      :to="doc.startLinkParams()"
    >
      {{ readingButton.text }}
    </AppButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import Highlight from '@/app/components/doc/highlights/Highlight.vue'
import AppButton from '@/app/components/button/AppButton.vue'

import { DocView } from '@/models/doc'

const props = withDefaults(
  defineProps<{
    doc: DocView
    limit?: number
    hideButtonOnMobile?: boolean
  }>(),
  {
    limit: 0,
    hideButtonOnMobile: false,
  },
)

const highlightsQty = computed(() => {
  if (props.limit === 0) {
    return props.doc.highlights.length
  }
  return props.limit
})

const readingButton = computed(() => {
  return props.doc.startReadingButton()
})

const hideButtonClass = computed(() => {
  return props.hideButtonOnMobile
    ? 'highlights__read-button--hide-on-mobile'
    : ''
})
</script>
